module.exports = __webpack_public_path__ + "static/media/D_Competitions.a6836bcd.png";